export default __webpack_public_path__ + "static/media/pe.83cbe7a2.svg";